import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchQuizTemplatesSaga() {
  try {
    const mockTemplates = [
      {
        id: 1,
        name: 'Multiple Choice Template',
        description: 'Standard MCQ format with 4 options',
        questionCount: 5,
        timeLimit: 600
      },
      {
        id: 2,
        name: 'Mixed Format Template',
        description: 'Combination of MCQ and short answers',
        questionCount: 8,
        timeLimit: 900
      }
    ];
    
    yield put(actions.fetchQuizTemplatesSuccess(mockTemplates));
  } catch (error) {
    yield put(actions.fetchQuizTemplatesFailure(error.message));
  }
}

function* fetchMyQuizzesSaga() {
  try {
    const mockQuizzes = [
      {
        id: 1,
        title: 'Programming Fundamentals Quiz',
        subject: 'Computer Science',
        questions: 5,
        timeLimit: 600,
        status: 'published',
        createdAt: '2024-01-15T10:00:00Z',
        attempts: 45,
        averageScore: 78
      },
      {
        id: 2,
        title: 'Data Structures Assessment',
        subject: 'Computer Science',
        questions: 8,
        timeLimit: 900,
        status: 'draft',
        createdAt: '2024-01-14T15:30:00Z',
        attempts: 0,
        averageScore: 0
      }
    ];
    
    yield put(actions.fetchMyQuizzesSuccess(mockQuizzes));
  } catch (error) {
    yield put(actions.fetchMyQuizzesFailure(error.message));
  }
}

function* createQuizSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 1500));
    
    const newQuiz = {
      id: Date.now(),
      ...action.payload,
      status: 'draft',
      createdAt: new Date().toISOString(),
      attempts: 0,
      averageScore: 0
    };
    
    yield put(actions.createQuizSuccess(newQuiz));
  } catch (error) {
    yield put(actions.createQuizFailure(error.message));
  }
}

function* updateQuizSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 1000));
    
    const updatedQuiz = {
      id: action.payload.quizId,
      ...action.payload.quizData,
      updatedAt: new Date().toISOString()
    };
    
    yield put(actions.updateQuizSuccess(updatedQuiz));
  } catch (error) {
    yield put(actions.updateQuizFailure(error.message));
  }
}

function* deleteQuizSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 500));
    yield put(actions.deleteQuizSuccess(action.payload));
  } catch (error) {
    yield put(actions.deleteQuizFailure(error.message));
  }
}

function* smeQuizCreationSaga() {
  yield takeEvery(types.FETCH_QUIZ_TEMPLATES_REQUEST, fetchQuizTemplatesSaga);
  yield takeEvery(types.FETCH_MY_QUIZZES_REQUEST, fetchMyQuizzesSaga);
  yield takeEvery(types.CREATE_QUIZ_REQUEST, createQuizSaga);
  yield takeEvery(types.UPDATE_QUIZ_REQUEST, updateQuizSaga);
  yield takeEvery(types.DELETE_QUIZ_REQUEST, deleteQuizSaga);
}

export default smeQuizCreationSaga;